import apiClient from "./axios";
import { ApiResponse } from "../types";

export type PaymentRequestStatus =
  | "open"
  | "partly_paid"
  | "settled"
  | "expired"
  | "cancelled";

export type PaymentRequestType = "single" | "group";

export interface PaymentRequestDelivery {
  sent: number;
  delivered: number;
  read: number;
  failed: number;
}

export interface AdminPaymentRequest {
  id: string;
  title: string;
  type: PaymentRequestType;
  status: PaymentRequestStatus;
  totalAmount: number;
  paidAmount: number;
  lineCount: number;
  paidCount: number;
  remindCount: number;
  lastRemindedAt: string | null;
  expiresAt: string | null;
  createdAt: string;
  creator: { name: string; email: string | null } | null;
  delivery: PaymentRequestDelivery;
}

export interface AdminPaymentRequestList {
  items: AdminPaymentRequest[];
  total: number;
  page: number;
  limit: number;
}

export interface GetPaymentRequestsParams {
  status?: PaymentRequestStatus;
  type?: PaymentRequestType;
  reminder?: "reminded" | "not_reminded" | "has_failed";
  search?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  limit?: number;
}

export interface AdminPaymentRequestLine {
  id: string;
  payeeLabel: string;
  payeePhone: string | null;
  payeeEmail: string | null;
  amount: number;
  status: "pending" | "paid";
  paidAt: string | null;
  isPayiqUser: boolean;
  waStatus: string | null;
  waStatusAt: string | null;
  payUrl: string;
}

export interface AdminPaymentRequestDetail extends AdminPaymentRequest {
  note: string | null;
  lines: AdminPaymentRequestLine[];
}

export const paymentRequestsApi = {
  list: async (params: GetPaymentRequestsParams) => {
    const { data } = await apiClient.get<ApiResponse<AdminPaymentRequestList>>(
      "/admin/requests",
      { params },
    );
    return data.data;
  },

  get: async (id: string) => {
    const { data } = await apiClient.get<ApiResponse<AdminPaymentRequestDetail>>(
      `/admin/requests/${id}`,
    );
    return data.data;
  },
};
